export const SET_AUTH_USER = 'SET_AUTH_USER'
export const SET_AUTH_USER_DATA = 'SET_AUTH_USER_DATA'
